import React , {useState} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage , pageLoaded,  reportAnalytics, getTechnicianTimeSlots, setSelectedTimeSlots, setCurrentSelectedTimeSlot,  updateTechnicianTimeSlot, resetTechnicianTimeSlots,  showMoreTimeSlots, setIsDisplayShowMoreBtn} from '../TechnicianUpdatesBlockSlice';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import TechnicianTimeSlots from '../Shared/TechnicianTimeSlots/TechnicianTimeSlots';
import TechnicianTimeSlotsCellcomHeader from '../Shared/TechnicianTimeSlotsCellcomHeader/TechnicianTimeSlotsCellcomHeader';

const TechnicianTimeSlotsCellcomPage = (props) => {
  const [showNotChooseTimeSlotErrorMsg , setShowNotChooseTimeSlotErrorMsg] = useState(false);

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);
    props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_5", eventLabel: "CELLCOM"});
  }, []);

  useExtendedEffect((runSideEffects) => { 
    if(props.technicianTimeSlotPage.timeSlots.length == props.technicianTimeSlots.timeSlots.length){
      props.setIsDisplayShowMoreBtn(false);
    }
  }, [props.technicianTimeSlotPage.timeSlots]);

  function onSelectedTimeSlot(timeSlot){
      props.setSelectedTimeSlots(timeSlot);
      setShowNotChooseTimeSlotErrorMsg(false);
      props.pageLoaded();
  }

  async function updateTechnicianVisit(){
    props.reportAnalytics({eventCategory: 'technician_update', eventAction: "click_2", eventLabel: "element_6"});

    if(props.currentSelectedTimeSlot == null){
      setShowNotChooseTimeSlotErrorMsg(true);
      props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_6", eventLabel: "element_7"});
    }
    else{
      var request = {
        SlotInfoCellcom: null,
        SlotInfoBezeq: null
      }
      if(props.selectedTimeSlots.length > 0) {
        props.selectedTimeSlots.forEach( timeSlot => {
          var slot = {
            OrderId: timeSlot.orderId,
            StartDate: timeSlot.startDate,
            EndTime: timeSlot.endTime,
            StartTime: timeSlot.startTime,
            StartDateTime: timeSlot.startDateTime
          }      
          if(timeSlot.type == "BEZEQ"){
            request.SlotInfoBezeq = slot;
          }
          if(timeSlot.type == "CELLCOM"){
            request.SlotInfoCellcom = slot;
          }
        })
      }
      props.showAppLoader();
      await props.updateTechnicianTimeSlot(request);
      props.hideAppLoader(); 
    }

  }


  async function  onClickShowMoreTimeSlotsBtn(){
    props.showMoreTimeSlots();
  }

  return (
    <div className='technician-time-slots-page'>      
       {props.technicianTimeSlots?.timeSlots?.length > 0 && 
        <>
          <TechnicianTimeSlotsCellcomHeader/>
          <TechnicianTimeSlots onSelectedTimeSlot={onSelectedTimeSlot} updateTechnicianVisit={updateTechnicianVisit} onClickShowMoreTimeSlotsBtn={onClickShowMoreTimeSlotsBtn} showNotChooseTimeSlotErrorMsg={showNotChooseTimeSlotErrorMsg} />
        </>
        }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    technicianTimeSlots : state.technicianUpdatesBlock.technicianTimeSlots,
    selectedTimeSlots: state.technicianUpdatesBlock.selectedTimeSlots,
    selectedVisit: state.technicianUpdatesBlock.selectedVisit,
    currentSelectedTimeSlot: state.technicianUpdatesBlock.currentSelectedTimeSlot,
    technicianTimeSlotPage: state.technicianUpdatesBlock.technicianTimeSlotPage
};
};

const mapDispatchToProps = {
  goToPage,
  pageLoaded,
  reportAnalytics,
  showAppLoader, 
  hideAppLoader,
  setSelectedTimeSlots,
  setCurrentSelectedTimeSlot,
  getTechnicianTimeSlots,
  updateTechnicianTimeSlot,
  resetTechnicianTimeSlots,
  showMoreTimeSlots,
  setIsDisplayShowMoreBtn
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianTimeSlotsCellcomPage);
